import { DateTime } from 'luxon';
import videojs from 'video.js';

/**
 * Formats milliseconds to seconds from the start of the day using Luxon
 */
function formatTimeToSecondsFromDayStart(milliseconds: number, tz: string): number {
  const dt = DateTime.fromMillis(milliseconds).setZone(tz);
  const secondsFromStart = dt.diff(dt.startOf('day'), 'seconds').seconds;

  return Math.floor(secondsFromStart);
}

const CurrentTimeDisplay = videojs.getComponent('CurrentTimeDisplay');

const original = (CurrentTimeDisplay.prototype as any).updateTextNode_;
(CurrentTimeDisplay.prototype as any).updateTextNode_ = function (content: string) {
  const player = this.player();
  const playerEl = player.el();

  // Check if data-initial-time attribute exists
  const initialTimeAttr = playerEl.getAttribute('data-time-from');
  const timeTzAttr = playerEl.getAttribute('data-time-tz');

  if (initialTimeAttr) {
    const initialTimeMs = parseFloat(initialTimeAttr);

    if (!isNaN(initialTimeMs)) {
      // initialTime is a JS timestamp in milliseconds
      // currentTime is in seconds, convert to milliseconds
      const currentTime = player.currentTime() || 0;
      const currentTimeMs = currentTime * 1000;
      const adjustedTimeMs = initialTimeMs + currentTimeMs;
      const formattedTime = formatTimeToSecondsFromDayStart(adjustedTimeMs, timeTzAttr);

      return original.call(this, formattedTime);
    }
  }

  return original.call(this, content);
};
